import BloodTubeIcon from 'src/components/svg/analyse/BloodTubeIcon';
import SugarBloodLevelIcon from 'src/components/svg/analyse/SugarBloodLevelIcon';
import XrayIcon from 'src/components/svg/analyse/XrayIcon';

const index = {
  'blood-tube-icon': BloodTubeIcon,
  'sugar-blood-level-icon': SugarBloodLevelIcon,
  'x-ray-icon': XrayIcon
};

export default index;
